<template>
  <div class="container mt-3">
    <div class="mt-3">
      <h3 class="title mb-3">FAQ 관리</h3>
    </div>

    <p class="mt-3 bold">※Drag&Drop으로 글의 순서를 변경할 수 있습니다. 글의 순서를 변경하고 <span class="red">반드시</span>“순서 저장하기” 버튼을 눌러 저장해주세요</p>

    <div class="mt-3 carrot-box p-3">
      <div class="d-flex justify-content-end"></div>
      <div class="d-flex">
        <div class="w-25per">
          <b-form-select v-model="selected" :options="compFaqCategoryList" @update:modelValue="changeCategory"> </b-form-select>
        </div>
      </div>
      <div class="mt-3">
        <!-- head -->
        <div class="draggable-item w-100per">
          <div class="p-2 w-5per txt-center head">
            <input type="checkbox" v-model="allChecked" />
          </div>
          <div class="p-2 w-20per txt-center bold head">카테고리</div>
          <div class="p-2 w-40per txt-center bold head">제목</div>
          <div class="p-2 w-25per txt-center bold head">작성일자</div>
          <div class="p-2 w-10per txt-center bold head">작성자</div>
        </div>
        <!-- body -->
        <template v-if="faqList.length > 0">
          <Container @drop="onDrop">
            <Draggable v-for="(faqItem, faqIdx) in faqList" :key="'faq' + faqIdx">
              <div class="draggable-item w-100per">
                <div class="p-2 w-5per txt-center drag-body">
                  <input type="checkbox" v-model="faqItem.isChecked" />
                </div>
                <div class="p-2 w-20per txt-center drag-body">{{ faqItem.categoryName }}</div>
                <div class="p-2 w-40per txt-center drag-body hyperlink" @click="onMove(`/faq/${faqItem.idx}`)">{{ faqItem.title }}</div>
                <div class="p-2 w-25per txt-center drag-body">{{ faqItem.createDate }}</div>
                <div class="p-2 w-10per txt-center drag-body">{{ faqItem.writer }}</div>
              </div>
            </Draggable>
          </Container>
        </template>
        <template v-else>
          <div class="draggable-item w-100per">
            <div class="w-100per txt-center drag-body p-2">검색결과가 없습니다.</div>
          </div>
        </template>
      </div>
      <div class="text-right mt-3">
        <b-button variant="secondary" :disabled="btnLoading ? true : false" @click="onMove('/faq/faqAdd')" class="me-2">글쓰기</b-button>
        <b-button variant="primary" :disabled="btnLoading ? true : false" class="me-2" @click="changeSort">순서 저장하기</b-button>
        <b-button variant="danger" :disabled="btnLoading ? true : false" @click="deleteFaqItem">삭제하기</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onActivated, onMounted, ref, watch } from '@vue/runtime-core';
import { useStore } from 'vuex';
import _ from 'lodash';
import { sugangGetFaqListApi, sugangChangeSortApi, sugangFaqDeleteApi } from '@/api/integrateapi/index';
import { Container, Draggable } from 'vue-dndrop';
import { applyDrag } from '@/utils/applyDrag';
import { useRouter } from 'vue-router';
export default {
  name: 'faqFaqList',
  components: {
    Container,
    Draggable,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const selected = ref(1);
    const faqList = ref([]);
    const btnLoading = ref(false);
    const allChecked = ref(false);

    const changeCategory = () => {
      allChecked.value = false;
      getFaqList();
    };

    const compFaqCategoryList = computed(() => {
      const copyFaqList = _.cloneDeep(store.getters.getFaqCategoryList);
      return copyFaqList;
    });

    const onDrop = dropResult => {
      const result = applyDrag(faqList.value, dropResult);
      faqList.value = result;

      //sort 변경
      faqList.value.forEach((item, index) => {
        item['sort'] = index + 1;
      });
    };

    const onMove = path => {
      router.push(path);
    };

    const getFaqList = () => {
      sugangGetFaqListApi(selected.value)
        .then(resp => {
          faqList.value = [];
          const { success, data: respData } = resp.data;
          if (success) {
            const { list } = respData;
            if (list.length > 0) {
              const sortList = list.sort((a, b) => {
                return a.sort - b.sort;
              });
              for (let i = 0; i < sortList.length; i++) {
                list[i]['isChecked'] = false;
                faqList.value.push(list[i]);
              }
            }
          }
        })
        .catch(error => {
          if (error.response) {
            // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // 요청이 이루어 졌으나 응답을 받지 못했습니다.
            // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
            // Node.js의 http.ClientRequest 인스턴스입니다.
            console.log(error.request);
          } else {
            // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
            console.log('Error', error.message);
          }
          console.log(error.config);
        })
        .finally(() => {});
    };

    const changeSort = () => {
      btnLoading.value = true;
      sugangChangeSortApi(selected.value, faqList.value)
        .then(resp => {
          const { success } = resp.data;
          if (success) {
            alert('순서 변경 저장에 성공하였습니다.');
            getFaqList();
          } else {
            alert('순서 변경 저장에 실패하였습니다.');
          }
        })
        .catch(error => {
          if (error.response) {
            alert(`순서 저장에 실패하였습니다.`);
            // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // 요청이 이루어 졌으나 응답을 받지 못했습니다.
            // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
            // Node.js의 http.ClientRequest 인스턴스입니다.
            console.log(error.request);
          } else {
            // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
            console.log('Error', error.message);
          }
          console.log(error.config);
        })
        .finally(() => {
          btnLoading.value = false;
        });
    };

    const deleteFaqItem = () => {
      const filFaq = faqList.value.filter(item => item['isChecked']);

      if (filFaq.length < 1) {
        alert('삭제할 FAQ를 선택해주세요');
        return false;
      }

      if (confirm('삭제 하시겠습니까?')) {
        console.log();
        btnLoading.value = true;
        sugangFaqDeleteApi(selected.value, filFaq)
          .then(resp => {
            const { success } = resp.data;
            if (success) {
              alert('FAQ  리스트 삭제에 성공하였습니다.');
              getFaqList();
            } else {
              alert('FAQ  리스트 삭제에 실패하였습니다.');
            }
          })
          .catch(error => {
            if (error.response) {
              alert('서버에 에러가 발생하였습니다.');
              // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            } else if (error.request) {
              // 요청이 이루어 졌으나 응답을 받지 못했습니다.
              // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
              // Node.js의 http.ClientRequest 인스턴스입니다.
              console.log(error.request);
            } else {
              // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
              console.log('Error', error.message);
            }
            console.log(error.config);
          })
          .finally(() => {
            btnLoading.value = false;
          });
      }
    };

    watch(
      () => allChecked.value,
      cur => {
        faqList.value.forEach(faqItem => {
          faqItem['isChecked'] = cur;
        });
      }
    );

    onMounted(() => {
      getFaqList();
    });

    onActivated(() => {
      getFaqList();
    });

    return {
      allChecked,
      compFaqCategoryList,
      selected,
      faqList,
      onDrop,
      changeCategory,
      changeSort,
      deleteFaqItem,
      btnLoading,
      onMove,
    };
  },
};
</script>

<style lang="scss" scoped>
.draggable-item {
  display: flex;
  border-top: 1px solid #e2e2e2;
  border-bottom: 1px solid #e2e2e2;

  .drag-item {
    padding: 10px 0;
    border-right: 1px solid #e2e2e2;
    border-bottom: 1px solid #e2e2e2;
  }
  .head {
    background-color: #f8f9fa;
    border-bottom: none !important;
    border-right: 1px solid #e2e2e2;
    border-left: 1px solid #e2e2e2;
  }

  .drag-body {
    border-right: 1px solid #e2e2e2;
    border-left: 1px solid #e2e2e2;
  }
}
</style>
